import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IGoalResponse } from 'app/features/goal/models/goal.models';
import { Observable } from 'rxjs';

export type GoalInformationQuery = {
  username: string;
  goal: number;
  limit?: number;
  page?: number;
};

@Injectable({ providedIn: 'root' })
export class GoalApiService {
  private readonly http: HttpClient = inject(HttpClient);

  getGoalInformation(query: GoalInformationQuery): Observable<IGoalResponse> {
    let params: HttpParams = new HttpParams()
      .set('goal', query.goal)
      .set('page', (query.page ?? 0) + 1);

    if (query.limit) params = params.set('limit', query.limit);

    const userAccessToken: string | null = localStorage.getItem('user_access_token');
    const headers: HttpHeaders = userAccessToken
      ? new HttpHeaders({ Authorization: `Bearer ${userAccessToken}` })
      : new HttpHeaders();

    return this.http.get<IGoalResponse>(
      environment.api.goal.data.replace(':username', query.username.toLowerCase()),
      { params, headers, responseType: 'json' }
    );
  }

  requestExport(username: string, email: string): Observable<void> {
    const url: string = environment.api.goal.export.replace(':username', username.toLowerCase());
    const params: HttpParams = new HttpParams().set('email', email);

    const userAccessToken: string | null = localStorage.getItem('user_access_token');
    const headers: HttpHeaders = userAccessToken
      ? new HttpHeaders({ Authorization: `Bearer ${userAccessToken}` })
      : new HttpHeaders();

    return this.http.get<void>(url, { params, headers });
  }

  resetGoal(username: string): Observable<unknown> {
    const url: string = environment.api.goal.reset.replace(':username', username.toLowerCase());
    const userAccessToken: string | null = localStorage.getItem('user_access_token');
    const headers: HttpHeaders = userAccessToken
      ? new HttpHeaders({ Authorization: `Bearer ${userAccessToken}` })
      : new HttpHeaders();

    return this.http.post<unknown>(url, {}, { headers });
  }
}
